import { useEffect, useRef, useState } from 'react';
import { Button, Form, ListGroup } from 'react-bootstrap';
import { useAuthenticateSuperAdminMutation } from '../../../features/authentication/authApiSlice';
import { useNavigate } from 'react-router';
import HesSpinner from '../../../components/loadingOverlay/hesSpinner';
import { useSelector } from 'react-redux';
import { selectCurrentToken, setCredentials } from '../../../features/authentication/authSlice';
import { useDispatch } from 'react-redux';

function SuperAdminLogin() {
  const superAdminPasswordRef = useRef();
  const [authenticateSuperAdmin, { isLoading }] = useAuthenticateSuperAdminMutation();
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const token = useSelector(selectCurrentToken);
  const dispatch = useDispatch();

  useEffect(() => {
    if(!token) navigate('/login');
  },[])

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');

    try {
      setError('');
      var authResponse = await authenticateSuperAdmin(superAdminPasswordRef.current.value).unwrap();

      dispatch(
        setCredentials({
          accessToken: authResponse.accessToken
        })
      );

      navigate('/dashboard');

    } catch (ex) {
      if (!ex?.status || ex.status === 'FETCH_ERROR') {
        setError('No server response');
      } else if (ex?.data?.reason) {
        setError(ex.data?.reason);
      } else {
        setError('Login was unsuccessful');
      }
    }
  }

  return (
    <>
      <ListGroup className="login-card-body flex-grow-1 flex-shrink-1" variant="flush">
        <ListGroup.Item>
          <div
            className="mx-auto text-color"
            style={{
              width: '90%',
              textAlign: 'center',
              fontWeight: '500',
              fontSize: '18px'
            }}>
            Super Admin Access
          </div>
        </ListGroup.Item>

        <Form onSubmit={handleSubmit}>
          <ListGroup.Item>
            <Form.Group id="userName">
              <Form.Label>Super Admin Password</Form.Label>
              <div>
                <Form.Control
                  className="loginTextBox"
                  type="password"
                  ref={superAdminPasswordRef}
                  required
                />
              </div>
            </Form.Group>
          </ListGroup.Item>

          <ListGroup.Item>
            <Button disabled={isLoading} variant="castleRed" className="submitButton" type="submit">
              {isLoading && <div style={{ position: 'absolute', top: '14px', bottom: '14px', left: '25%' }}><HesSpinner /></div>}
              Submit
            </Button>
          </ListGroup.Item>
        </Form>

        {error && (
          <ListGroup.Item>
            <div className="d-flex flex-column align-content-center">
              <div className='mx-auto error'>
                {error}
              </div>
            </div>
          </ListGroup.Item>
        )}

        <ListGroup.Item className='flex-grow-1 flex-shrink-1'>
        </ListGroup.Item>

        <ListGroup.Item>
          <Button
            variant="castleWhite"
            className="backButton"
            onClick={() => navigate('/login')}>
            Back to Login
          </Button>
        </ListGroup.Item>

        
      </ListGroup>
    </>
  );
}

export default SuperAdminLogin;
